/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.179.0-v202608122344-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqScalarsApiClass {
 
   constructor() {}

  /**
   * @summary Archive a scalar
   * @param {string} id - ID of the scalar to archived
  */
  public archiveScalar(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/scalars/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a calculated scalar
  */
  public createCalculatedScalar(
    body: models.ScalarInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/scalars`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CalculatedItemOutputV1>;
  }

  /**
   * @summary Get a scalar
   * @param {string} id - ID of the scalar to retrieve
  */
  public getScalar(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/scalars/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.CalculatedItemOutputV1>;
  }

  /**
   * @summary Get the resulting value from a scalar
   * @param {string} id - ID of the scalar to find the value of
  */
  public getScalarValue(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/scalars/${encodeURIComponent(String(id))}/getValue`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ScalarEvaluateOutputV1>;
  }

  /**
   * @summary Get a collection of scalars
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getScalars(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/scalars`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Create or update multiple scalars at one time
  */
  public putScalars(
    body?: models.PutScalarsInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/scalars/batch`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemBatchOutputV1>;
  }

}


export const sqScalarsApi = new sqScalarsApiClass();

export type sqScalarsApiEndpoints = {
  'archiveScalar': {
    method: 'delete';
    path: '/scalars/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'createCalculatedScalar': {
    method: 'post';
    path: '/scalars';
    response: models.CalculatedItemOutputV1;
  };
  'getScalar': {
    method: 'get';
    path: '/scalars/${encodeURIComponent(String(id))}';
    response: models.CalculatedItemOutputV1;
  };
  'getScalarValue': {
    method: 'get';
    path: '/scalars/${encodeURIComponent(String(id))}/getValue';
    response: models.ScalarEvaluateOutputV1;
  };
  'getScalars': {
    method: 'get';
    path: '/scalars';
    response: models.ItemPreviewListV1;
  };
  'putScalars': {
    method: 'post';
    path: '/scalars/batch';
    response: models.ItemBatchOutputV1;
  };
};

type ApiArchiveScalarResponse = models.ArchiveOutputV1;
type ApiarchiveScalarMutationParams = Parameters<typeof sqScalarsApi.archiveScalar> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqScalarsApi.archiveScalar>;

export function useApiArchiveScalarMutation(
  options?: Omit<UseMutationOptions<ApiArchiveScalarResponse, AxiosError<SeeqErrorData>,
    ApiarchiveScalarMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveScalarResponse, AxiosError<SeeqErrorData>,
  ApiarchiveScalarMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveScalarMutationParams) =>
      sqScalarsApi.archiveScalar(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateCalculatedScalarResponse = models.CalculatedItemOutputV1;
type ApicreateCalculatedScalarMutationParams = Parameters<typeof sqScalarsApi.createCalculatedScalar> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqScalarsApi.createCalculatedScalar>;
type ApicreateCalculatedScalarMutationVariables = models.ScalarInputV1;

export function useApiCreateCalculatedScalarMutation(
  options?: Omit<UseMutationOptions<ApiCreateCalculatedScalarResponse, AxiosError<SeeqErrorData>,
    ApicreateCalculatedScalarMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateCalculatedScalarResponse, AxiosError<SeeqErrorData>,
  ApicreateCalculatedScalarMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateCalculatedScalarMutationVariables) =>
      sqScalarsApi.createCalculatedScalar(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetScalarResponse = models.CalculatedItemOutputV1;
export function GetScalarQueryKey(
  params: Parameters<typeof sqScalarsApi.getScalar>[0],
) {
  return ['sqScalarsApi', 'getScalar', params] as const;
}

export function useApiGetScalarQuery(
  params: Parameters<typeof sqScalarsApi.getScalar>[0],
  options?: Omit<UseQueryOptions<ApiGetScalarResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetScalarResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetScalarQueryKey(params),
    queryFn: () =>
      sqScalarsApi.getScalar(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetScalarValueResponse = models.ScalarEvaluateOutputV1;
export function GetScalarValueQueryKey(
  params: Parameters<typeof sqScalarsApi.getScalarValue>[0],
) {
  return ['sqScalarsApi', 'getScalarValue', params] as const;
}

export function useApiGetScalarValueQuery(
  params: Parameters<typeof sqScalarsApi.getScalarValue>[0],
  options?: Omit<UseQueryOptions<ApiGetScalarValueResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetScalarValueResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetScalarValueQueryKey(params),
    queryFn: () =>
      sqScalarsApi.getScalarValue(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetScalarsResponse = models.ItemPreviewListV1;
export function GetScalarsQueryKey(
  params: Parameters<typeof sqScalarsApi.getScalars>[0],
) {
  return ['sqScalarsApi', 'getScalars', params] as const;
}

export function useApiGetScalarsQuery(
  params: Parameters<typeof sqScalarsApi.getScalars>[0],
  options?: Omit<UseQueryOptions<ApiGetScalarsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetScalarsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetScalarsQueryKey(params),
    queryFn: () =>
      sqScalarsApi.getScalars(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPutScalarsResponse = models.ItemBatchOutputV1;
type ApiputScalarsMutationParams = Parameters<typeof sqScalarsApi.putScalars> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqScalarsApi.putScalars>;
type ApiputScalarsMutationVariables = models.PutScalarsInputV1 | undefined;

export function useApiPutScalarsMutation(
  options?: Omit<UseMutationOptions<ApiPutScalarsResponse, AxiosError<SeeqErrorData>,
    ApiputScalarsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPutScalarsResponse, AxiosError<SeeqErrorData>,
  ApiputScalarsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApiputScalarsMutationVariables) =>
      sqScalarsApi.putScalars(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
